const routes = {
  root: '/sso',
  login: '/sso/login',
  confirm: '/sso/session/confirm',
  logout: '/sso/session/terminate',
}

export default routes
